import { render } from "./gmdetail.vue?vue&type=template&id=b0802428&scoped=true"
import script from "./gmdetail.vue?vue&type=script&lang=js"
export * from "./gmdetail.vue?vue&type=script&lang=js"

import "./gmdetail.vue?vue&type=style&index=0&id=b0802428&lang=scss&scoped=true"
import "./gmdetail.vue?vue&type=style&index=1&id=b0802428&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0802428"]])

export default __exports__